import { createFileRoute } from "@tanstack/react-router";
import { LancamentosPage } from "@/pages/LancamentosPage";

export const Route = createFileRoute("/lancamentos/")({
  head: () => ({ meta: [{ title: "Lançamentos — AXIS Comprovantes" }] }),
  component: () => <LancamentosPage />,
});
